import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  myTeamReports: {
    data: [],
    loading: false,
    count: 0,
    completionPercents: "0.00",
    readyForReview: 0,
    openReports: 0,
  },
  reportsAssignedByUser: {
    data: [],
    loading: false,
    count: 0,
  },
  assignedToMeOpen: {
    data: [],
    loading: false,
    count: 0,
  },
  assignedToMeArchive: {
    data: [],
    loading: false,
    count: 0,
  },
};

const coachup = createSlice({
  name: "coachup",
  initialState,
  reducers: {
    getMyTeamReportsRequest(state) {
      state.myTeamReports.loading = true;
    },
    getMyTeamReportsSuccess(state, action) {
      state.myTeamReports.data = action.payload?.data?.rows;
      state.myTeamReports.count = action.payload?.data?.count;
      state.myTeamReports.completionPercents = action.payload?.completionPercents;
      state.myTeamReports.readyForReview = action.payload?.readyForReview || 0;
      state.myTeamReports.openReports = action.payload?.openReports;
      state.myTeamReports.loading = false;
    },
    getMyTeamReportsFailure(state) {
      state.myTeamReports.data = [];
      state.myTeamReports.loading = false;
      state.myTeamReports.count = 0;
    },

    // other reports listing
    getReportsAssignedByUserRequest(state) {
      state.reportsAssignedByUser.loading = true;
    },
    getReportsAssignedByUserSuccess(state, action) {
      state.reportsAssignedByUser.data = action.payload?.data?.rows;
      state.reportsAssignedByUser.count = action.payload?.data?.count;
      state.reportsAssignedByUser.loading = false;
    },
    getReportsAssignedByUserFailure(state) {
      state.reportsAssignedByUser.data = [];
      state.reportsAssignedByUser.loading = false;
      state.reportsAssignedByUser.count = 0;
    },
    // ASSIGNED TO ME 'OPEN'
    getAssignedToMeOpenRequest(state) {
      state.assignedToMeOpen.loading = true;
    },
    getAssignedToMeOpenSuccess(state, action) {
      state.assignedToMeOpen.data = action.payload?.data?.rows;
      state.assignedToMeOpen.count = action.payload?.data?.count;
      state.assignedToMeOpen.loading = false;
    },
    getAssignedToMeOpenFailure(state) {
      state.assignedToMeOpen.data = [];
      state.assignedToMeOpen.loading = false;
      state.assignedToMeOpen.count = 0;
    },

    // ASSIGNED TO ME 'ARCHIVE'
    getasAssignedToMeArchiveRequest(state) {
      state.assignedToMeArchive.loading = true;
    },
    getAssignedToMeArchiveSuccess(state, action) {
      state.assignedToMeArchive.data = action.payload?.data?.rows;
      state.assignedToMeArchive.count = action.payload?.data?.count;
      state.assignedToMeArchive.loading = false;
    },
    getAssignedToMeArchiveFailure(state) {
      state.assignedToMeArchive.data = [];
      state.assignedToMeArchive.loading = false;
      state.assignedToMeArchive.count = 0;
    },
  },
});
export const coachupAction = coachup.actions;
export default coachup.reducer;
